import { render, staticRenderFns } from "./snackbarMessage.vue?vue&type=template&id=511f38bb&"
import script from "./snackbarMessage.vue?vue&type=script&lang=ts&"
export * from "./snackbarMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports